import axios from 'axios'

export const state = {
  sources: null,
}

export const getters = {
  sources: (state) => state.sources,
  sourceOptions: (state) =>
    state.sources &&
    state.sources.map(({ title }) => ({ id: title, label: title })),
}

export const mutations = {
  SET_SOURCES(state, sources) {
    state.sources = sources
  },
}

export const actions = {
  fetchAllSources({ commit, state, rootState }) {
    return axios.get('/api/sources').then((response) => {
      const sources = response.data
      commit('SET_SOURCES', sources)
      return sources
    })
  },
}
